<template lang="pug">
include /@ibkr/lib.common/src/icon/basic
ib-dropdown(
    v-model="searchFilter",
    :data="options",
    :placeholder="$t('search')",
    filtered,
    :width="$media.m ? '380px' : '100%' ",
    @change="selectOption"
)
</template>

<script>
    export default {
        name: 'SelectDrop',

        data() {
            return {
                searchFilter: undefined,
            }
        },

        methods: {
            selectOption() {
                this.$emit('getSelect', this.searchFilter);
            },

            reset() {
                this.searchFilter = this.defaultValue;
            }
        },

        props: {
            options: Array,
            defaultValue: String,
            filterFor: String
        },

        mounted() {
            this.searchFilter = this.defaultValue;
        }
    }
</script>